import gql from 'graphql-tag';

export default gql`
    query GetWellheadsByStageGroupId($stageGroupId: Int) {
        getWellheadsByStageGroupId(stageGroupId: $stageGroupId) {
            jobStageId
            stage
            overallStage
            wellhead
            status
            stageSheetId
            stageSheetDescrip
            fracType
        }
    }
`;
